import { Component, Input, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'read-more-html',
  templateUrl: './read-more-html.component.html',
  styleUrls: ['./read-more-html.component.css'],
})
export class ReadMoreHtmlComponent implements AfterViewInit {
  //the text that need to be put in the container
  @Input() content: string;

  //maximum height of the container
  @Input() maxHeight: number = 100;

  //set these to false to get the height of the expended container
  public isCollapsed: boolean = false;
  public isCollapsable: boolean = false;
  public currentHeight;
  public isInit: boolean = false;
  public isChanged: boolean = false;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.check();
  }

  check() {
    this.currentHeight = this.elementRef.nativeElement.getElementsByClassName('auto')[0] ? this.elementRef.nativeElement.getElementsByClassName('auto')[0].offsetHeight : 0;
    if (this.currentHeight == 0) {
      setTimeout(() => this.check(), 500);
      return;
    }
    //collapsable only if the contents make container exceed the max height
    if (this.currentHeight > this.maxHeight) {
      if (!this.isChanged) {
        this.isCollapsed = true;
      }
      this.isCollapsable = true;
    }
    this.isInit = true;
    setTimeout(() => this.check(), 1000);
  }

  changeIsCollapsed(event) {
    event?.stopPropagation();
    this.isChanged = true;
    this.isCollapsed = !this.isCollapsed;
  }
}
